module.exports = __webpack_public_path__ + "img/icon-c-button.cf406447.svg";